// removed by extract-text-webpack-plugin
module.exports = {"container":"CopyMeetingDetails-container","copyMeetingDetails":"CopyMeetingDetails-copyMeetingDetails"};